"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CSVOutput_1 = require("./_CSVOutput");
var _JSONOutput_1 = require("./_JSONOutput");
exports._OutputSerialization = {
    type: "structure",
    required: [],
    members: {
        CSV: {
            shape: _CSVOutput_1._CSVOutput
        },
        JSON: {
            shape: _JSONOutput_1._JSONOutput
        }
    }
};
//# sourceMappingURL=_OutputSerialization.js.map